/**
 * @generated SignedSource<<6de8878a1fb7b136428ebcdd09cb135f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "closeNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CloseNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CloseNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29e5160c01265d3f4c932af38274fd77",
    "id": null,
    "metadata": {},
    "name": "CloseNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation CloseNominatedTradeMutation(\n  $id: ID!\n) {\n  closeNominatedTrade(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "70149bbc6c9a4df41337c45e8f2085b1";

module.exports = node;
